<template>
  <v-subheader
    class="password-error pl-0 pt-1 pb-2 ma-0"
    :class="
      !isActive && !passwordRegex.test(password)
        ? 'text-red'
        : passwordRegex.test(password) && 'text-green'
    "
    v-if="password"
  >
    <span class="password-error__space">
      {{ $t("password_validation.minimum") }}
    </span>
    <span
      :class="{
        'password-error__success text-green': /^.{8,}$/.test(password),
      }"
    >
      {{ $t("password_validation.characters") }}
    </span>
    <span class="password-error__space">,</span>
    <span
      :class="{
        'password-error__success text-green': /^(?=.*[a-z])/.test(password),
      }"
    >
      {{ $t("password_validation.lowercase") }}
    </span>
    <span class="password-error__space">,</span>
    <span
      :class="{
        'password-error__success text-green': /^(?=.*[A-Z])/.test(password),
      }"
    >
      {{ $t("password_validation.uppercase") }}
    </span>
    <span class="password-error__space">,</span>
    <span
      :class="{
        'password-error__success text-green': /^(?=.*[0-9])/.test(password),
      }"
    >
      {{ $t("password_validation.number") }}
    </span>
  </v-subheader>
</template>

<script>
import { passwordRegex } from "@/utils/constants";

export default {
  name: "niko-password-error",
  props: ["password", "isActive"],
  data: () => ({
    passwordRegex: passwordRegex,
  }),
  watch: {
    password(value) {
      this.$emit("isError", !passwordRegex.test(value));
    },
  },
};
</script>

<style lang="scss">
.password-error {
  flex-wrap: wrap;
  height: auto;
  position: relative;

  &.text-red:before {
    content: "";
    height: 90px;
    width: 4px;
    background: var(--v-error-base);
    position: absolute;
    left: -12px;
    top: -66px;
  }

  &__space {
    margin-right: 0.3em;
  }

  &__success {
    text-decoration: line-through;
  }
}
</style>
